import { StarIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Flex, IconButton } from '@/components/common';
import { useFilterStore } from '@/stores/filterStore';
import { PageTopBar, PulpLogo } from '../layout';
import { DiscoveryFilterDialog } from './DiscoveryFilterDialog';
import { LiveTodayPill } from './LiveTodayPill';

export function DiscoveryHeader() {
  const { t } = useTranslation('discover');
  const favoritesOnly = useFilterStore(s => s.favoritesOnly);
  const setFavoritesOnly = useFilterStore(s => s.setFavoritesOnly);

  return (
    <PageTopBar
      startSlot={<PulpLogo size="9" variant="simple" />}
      endSlot={
        <Flex align="center" gap="2">
          <LiveTodayPill />
          <IconButton
            type="button"
            variant={favoritesOnly ? 'solid' : 'outline'}
            color={favoritesOnly ? 'red' : 'gray'}
            highContrast={!favoritesOnly}
            radius="full"
            size="2"
            aria-label={t('header.favorites')}
            aria-pressed={favoritesOnly}
            data-testid="favorites-toggle"
            onClick={() => setFavoritesOnly(!favoritesOnly)}
          >
            <StarIcon size={20} fill={favoritesOnly ? 'currentColor' : 'none'} aria-hidden />
          </IconButton>
          <DiscoveryFilterDialog />
        </Flex>
      }
    />
  );
}
